<template>
  <div>
    <!--General Top Bar -->
    <general-top-bar :title="$t('reports.salesTrendsReport')"></general-top-bar>
    <!--End General Top Bar -->
    <div class="sales-report">
      <div class="row mar-bt-15">
        <!-- Left Column -->
        <div class="col-md-6">
          <div class="mb-3 w-100" v-if="showLocations">
            <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control mar-bt-15" v-model="orders.location">
              <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <template v-for="loc in locations">
                <option :label="loc.name" :value="loc.id">{{loc.name}}</option>
              </template>
            </select>
          </div>
        </div>
        
        <!-- Right Column -->
        <div class="col-md-6">
        </div>
      </div>

      <div class="col-md-12">
        <p class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>
        </p>
        <div class="pull-left search-button-reports">
          <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
        </div>
        <div class="search-button-reports form-group pull-left">
          <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="exportData()">{{$t('general.download_xls') }} <img src="/static/img/export_xls.png"></div>
        </div>
      </div>
      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;">{{ $t('reports.filteredData') }} <b>{{orders.valid[0]}} {{valid_from}}:00</b> - <b>{{orders.valid[1]}} {{valid_to}}:59</b></p>
      </div>

      <div class="col-md-12">
        <!-- <div class="card"> -->
          <div class="card-content total-pagination reports-center-columns">
            <line-chart :chartData="chartData" :options="chartOptions" />
          </div>
        <!-- </div> -->
      </div>
      <div class="col-md-12" style="margin-top: 15px;">
        <data-tables-server
          v-loading="loading"
          :data="ordersTableData.data"
          :search-def="{show: false}"
          @query-change="paginationChanged"
          :total="ordersTableData.total"
          :pagination-props="paginationProps"
          class="report-sales"
          key="sales-table"
          style="width: 100%"
          ref="reportsTable">
            <el-table-column class-name="centered-cell" :min-width="80" prop="sale_week" :label="$t('reports.saleWeek')">
              <template slot-scope="props">
                {{ getSalePeriod(props.row.sale_week) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="counter" :label="$t('reports.orderCounter')">
              <template slot-scope="props">
                {{ Number(props.row.counter) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="sold" :label="$t('reports.revenue')">
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.sold)) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="item_level_discount" :label="$t('reports.orderItemDiscount')">
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.item_level_discount)) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="order_level_discount" :label="$t('reports.orderDiscount')">
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.order_level_discount)) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="discount" :label="$t('reports.discount')">
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.item_level_discount) + Number(props.row.order_level_discount)) }}
              </template>
            </el-table-column>
        </data-tables-server>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {DatePicker} from 'element-ui'
import moment from 'moment'
import swal from 'sweetalert2'
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import LineChart from 'src/components/UIComponents/Cards/LineChart.vue'

export default {
  components: {
    GeneralTopBar,
    [DatePicker.name]: DatePicker,
    LineChart
  },
  props: {
    isSalesTrend: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isSalesTrend () {
      if (this.isSalesTrend) {
        this.getOrders()
        this.verifyUserLocations()
        this.verifyUserMethods()
      }
    }
  },
  // created () {
  //   this.getOrders()
  //   this.verifyUserLocations()
  //   this.verifyUserMethods()
  // },
  data () {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      productsTableData: [],
      productsTableDataTotals: {},
      paymentMethods: [],
      receiptOptions: [
        { label: this.$t('reports.withoutReceipt'), value: 1 },
        { label: this.$t('reports.withReceipt'), value: 2 }
      ],
      selectedDriver: '',
      selected_user: '',
      selected_order_from: '',
      selected_payment_method: '',
      loading: true,
      loadingProducts: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        // 'valid': [  // luna curenta
        //   moment().date(1).format('YYYY-MM-DD'),
        //   moment().endOf('month').format('YYYY-MM-DD')
        // ],
        'valid': [
          moment().date(1).format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      },
      ordersTableData: {},
      totals: {
        total: 0,
        totalCash: 0,
        totalVirament: 0,
        totalOnline: 0,
        totalProtocol: 0,
        totalCard: 0,
        totalPOS: 0,
        totalCARDPOS: 0,
        totalTips: 0,
        totalDiscount: 0,
        totalTax: 0,
        totalShipping: 0,
        avarageOrderValue: 0
      },
      totalOrders: null,
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '550px',
          width: '550px'
        }
      },
      chartData: {
        labels: [],
        datasets: []
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Vânzari',
              fontColor: 'red',
              fontSize: 22
            },
            ticks: { beginAtZero: true }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Data',
              fontColor: 'red',
              fontSize: 22
            }
          }]
        }
      },
      // use_tips: this.$session.get('tips_use')
      use_tips: true,
      hasRceipt: null,
      noData: false,
      selectedProducts: [],
      availableProducts: [],
      allProductsMap: new Map()
    }
  },
  methods: {
    searchProducts (query) {
      if (!query) {
        return
      }
      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      this.loadingProducts = true

      this.apiRequest('/search-order-products', 'GET', data, response => {
        if (response.status) {
          response.data.forEach(item => {
            this.allProductsMap.set(item.id, item)
          })

          this.availableProducts = response.data
        } else {
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loadingProducts = false
        })
      })
    },
    clearSearch () {
      this.$refs.productSelect.focus()
      const select = this.$refs.productSelect

      if (select) {
        select.query = ''
        select.handleQueryChange('')
      }
    },
    getPaymentMethods () {
      let sessionData = this.$session.get('selectedCompanyData')

      if (!sessionData['payment_methods']) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        this.apiRequest('/orders/get-payment-methods', 'GET', data, (response) => {
          if (response.status && response.data.length) {
            let result = response.data.map(item => {
              return {id: item || 'unpaid', name: this.$t('paymentTypes.' + item)}
            })
            sessionData['payment_methods'] = response.data
            this.$session.set('selectedCompanyData', sessionData)

            Vue.set(this, 'paymentMethods', result)
          }
        })
      } else {
        let result = sessionData['payment_methods'].map(item => {
          return {id: item || 'unpaid', name: this.$t('paymentTypes.' + item)}
        })
        Vue.set(this, 'paymentMethods', result)
      }
    },
    summaryTotal () {
      const result = {
        revenue: 0,
        quantity: 0,
        discount: 0,
        vat: 0
      }

      this.productsTableData.forEach(item => {
        result.revenue += Number(item.total_revenue || 0)
        result.quantity += Number(item.quantity_sold || 0)
        result.discount += Number(item.discount || 0)
        result.vat += Number(item.vat || 0)
      })

      return result
    },
    startDownload () {
      this.loading = true
    },
    finishDownload () {
      this.loading = false
    },
    changeValidFrom () {
      // if (this.valid_to <= this.valid_from) {
      //   this.valid_to = '23:59'
      // }
      if (!this.valid_from) {
        this.valid_from = '00:00'
      }
      if (!this.valid_to) {
        this.valid_to = '23:59'
      }
    },
    paginationChanged (query) {
      if (query.type === 'page') this.getOrders(query)
      if (query.type === 'size') this.getOrders(query)
      if (query.type === 'sort') this.getOrders(query)
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
        id: location.true_id,
        name: location.name
      }))

      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))

        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }

      if (this.locations.length > 1) {
        this.showLocations = true
      }

      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.orders.location = filterCookie[0]
      }
    },
    verifyUserMethods () {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels
      this.showMethods = true
    },
    getOrders (query) {
      if (!this.isSalesTrend) {
        return
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }
      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: this.orders.valid[0],
        to_date: this.orders.valid[1]
      }
      if (this.selectedProducts && this.selectedProducts.length) {
        data.product_ids = this.selectedProducts.map(table => table.id)
      }
      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }
      this.loading = true

      this.apiRequest('/reports/v2/sales-trends', 'GET', data, response => {
        if (response.status) {
          if (response.data.table_data.length) {
            this.ordersTableData.data = response.data.table_data
            this.ordersTableData.total = response.data.table_data.length
            this.paginationProps.currentPage = 1
            this.paginationProps.pageSize = 20
          } else {
            this.ordersTableData.data = []
            this.ordersTableData.total = 0
            this.paginationProps.pageSize = 20
          }

          this.$nextTick(() => {
            this.chartData = {
              labels: response.data.labels,
              datasets: response.data.datasets
            }
          })
        } else {
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    updateData () {
      this.getOrders()
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    },
    exportData () {
      let fromDate = this.orders.valid[0]
      let toDate = this.orders.valid[1]

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      this.loading = true
      this.apiRequest('/reports/v2/sales-trends-download', 'GET', data, response => {
        if (response.status === true) {
          const link = document.createElement('a')
          link.href = response.data.file
          link.setAttribute('download', response.data.file_name)
          document.body.appendChild(link)
          link.click()
        } else {
          swal(
            '',
            this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.loading = false
      })
    },
    getSalePeriod (saleWeek) {
      const year = parseInt(saleWeek.toString().slice(0, 4))
      const week = parseInt(saleWeek.toString().slice(4))

      // Create a date for the first day of the year
      const firstDayOfYear = new Date(Date.UTC(year, 0, 1))
      const dayOfWeek = firstDayOfYear.getUTCDay() // 0 (Sun) to 6 (Sat)

      // ISO weeks start on Monday, so adjust
      const dayOffset = (dayOfWeek <= 4 ? dayOfWeek - 1 : dayOfWeek - 8)
      const firstMonday = new Date(firstDayOfYear)
      firstMonday.setUTCDate(firstDayOfYear.getUTCDate() - dayOffset)

      // Get Monday of the target week
      const weekStart = new Date(firstMonday)
      weekStart.setUTCDate(firstMonday.getUTCDate() + (week - 1) * 7)

      // Get Sunday of the same week
      const weekEnd = new Date(weekStart)
      weekEnd.setUTCDate(weekStart.getUTCDate() + 6)

      // Format to YYYY-MM-DD
      const formatDate = (d) => d.toISOString().slice(0, 10)

      return `${formatDate(weekStart)} - ${formatDate(weekEnd)}`
    }
  }
}
</script>
<style>
  .ct-label {
    display: none;
  }
  .ct-legend-inside .inactive {
    opacity: 0.3;
  }
  .cell b {
    word-break: break-word;
  }
  .card .details h6 {
    text-align: left;
    font-weight: 500;
  }
  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 70px;
  }
  .report-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .sales-report .sales-height .card {
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
  .sales-report .sales-height:nth-child(1) .card {
    align-items: center;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 650px;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }
  /* .ct-label.ct-horizontal {
    white-space: pre-line;
    text-anchor: middle;
    font-size: 12px;
  } */
  .ct-label.ct-horizontal {
    font-size: 12px !important;
    text-anchor: middle !important;
  }
  foreignObject div {
    font-size: 12px;
    line-height: 1.2em;
    text-align: center;
    color: #333;
  }

  .ct-label .ct-vertical {
    font-size: 12px;
    overflow: visible !important;
  }

  /* .ct-chart {
    overflow: visible !important;
  } */

  .ct-chart {
    padding-top: 20px; /* or more */
    overflow: visible !important;
  }

  .centered-cell .cell {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>

<style scopped>
  .el-select .el-tag {
    background-color: #674BD2 !important;
    color: white;
    /* font-size: 16px; */
    padding: 2px 12px;
  }

  span .el-tag {
    padding-top: 7px !important;
    height: 36px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/SalesTrend.vue